import React from 'react';
export function CourseSchedule() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2345">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2346">
        <div className="mb-12" data-id="element-2347">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2348">
            Course Schedule
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2349">
            <div className="bg-white rounded-xl p-6 shadow-sm border text-center" style={{
            borderColor: '#ede9e0'
          }} data-id="element-2350">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center mx-auto mb-3 font-bold" style={{
              backgroundColor: '#1e3d2f',
              color: '#ffffff',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-2351">
                1
              </div>
              <h3 className="text-lg font-bold uppercase mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-2352">
                Day 1
              </h3>
              <p className="text-2xl font-bold mb-1" style={{
              color: '#c8a84b',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-2353">
                9 Hours
              </p>
              <p className="text-sm text-gray-500" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2354">
                Classroom & range instruction
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm border text-center" style={{
            borderColor: '#ede9e0'
          }} data-id="element-2355">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center mx-auto mb-3 font-bold" style={{
              backgroundColor: '#1e3d2f',
              color: '#ffffff',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-2356">
                2
              </div>
              <h3 className="text-lg font-bold uppercase mb-1" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-2357">
                Day 2
              </h3>
              <p className="text-2xl font-bold mb-1" style={{
              color: '#c8a84b',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-2358">
                5+ Hours
              </p>
              <p className="text-sm text-gray-500" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2359">
                Continued instruction & examination
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}